
import React from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface EmptyStateProps {
  hasFilters: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({ hasFilters }) => {
  return (
    <Alert>
      <AlertDescription>
        {hasFilters
          ? "Geen berichten gevonden met deze filters."
          : "Er zijn nog geen feedback berichten. Wees de eerste die feedback geeft!"}
      </AlertDescription>
    </Alert>
  );
};

export default EmptyState;
